import styled from "styled-components";
import {
  BANNER_HEIGHT,
  HEADER_HEIGHT,
  HEADER_HEIGHT_MOBILE,
} from "../../lib/constants";

export const StyledAppLayout = styled.div`
  position: relative;
  min-height: 100vh;
  background-color: white;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  main {
    max-width: 1440px;
    margin: 0 auto;
    padding: ${({ $hasTopBanner }) =>
        HEADER_HEIGHT + ($hasTopBanner ? BANNER_HEIGHT : 0)}px
      0 0;

    @media ${({ theme }) => theme.media.mobileForHeader} {
      padding-top: ${({ $hasTopBanner }) =>
        HEADER_HEIGHT_MOBILE + ($hasTopBanner ? BANNER_HEIGHT : 0)}px;
      overflow: hidden; /* for fixed header */
    }
  }
`;
